package com.shadowings.gero.data.lessons.chapter10

import com.shadowings.gero.data.lessons.chapter1.getFamousNamesQuiz
import com.shadowings.gero.data.lessons.chapter1.getIntroHieroglyphs2QuizContent
import com.shadowings.gero.data.lessons.chapter1.getIntroductionHieroglyphsQuizContent
import com.shadowings.gero.data.lessons.chapter1.getUni_1QuizContent
import com.shadowings.gero.data.lessons.chapter1.getUni_2QuizContent
import com.shadowings.gero.data.repository.Hiero
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_la_teoria_1
import gero.composeapp.generated.resources.exp_content_la_teoria_2
import gero.composeapp.generated.resources.exp_content_la_teoria_3
import gero.composeapp.generated.resources.exp_content_la_teoria_4
import gero.composeapp.generated.resources.exp_content_la_teoria_5
import gero.composeapp.generated.resources.exp_content_la_teoria_6
import gero.composeapp.generated.resources.exp_content_la_teoria_7
import gero.composeapp.generated.resources.exp_title_la_teoria

fun getLaTeoriaContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_la_teoria,
            content = Res.string.exp_content_la_teoria_1,
            face = Faces.Happy,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_teoria,
            content = Res.string.exp_content_la_teoria_2,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_teoria,
            content = Res.string.exp_content_la_teoria_3,
            face = Faces.Serious,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_teoria,
            content = Res.string.exp_content_la_teoria_4,
            face = Faces.Surprised,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_teoria,
            content = Res.string.exp_content_la_teoria_5,
            face = Faces.Surprised,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_teoria,
            content = Res.string.exp_content_la_teoria_6,
            face = Faces.Doubt,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_teoria,
            content = Res.string.exp_content_la_teoria_7,
            face = Faces.Happy,
            character = Characters.Alyn,
        )
    )
}

fun getLaTeoriaQuizContent(
    hiero: List<Hiero>,
    words: List<Word>,
    languageCode: String
): List<IQuizContent> {
    return (
        getIntroductionHieroglyphsQuizContent().shuffled().take(1)
            + getIntroHieroglyphs2QuizContent().shuffled().take(1)
            + getUni_1QuizContent(hiero, words, languageCode).shuffled().take(1)
            + getUni_2QuizContent(hiero, words, languageCode).shuffled().take(1)
            + getFamousNamesQuiz(words, languageCode).shuffled().take(6)
    ).shuffled()
}
